import axios from "axios";

export default axios.create({
  baseURL: "https://gpsdogstracking.com",
  headers: {
    "Content-type": "application/json",
  },
});
